import { Component,Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidacionesService } from '../../validaciones.service';
import { Validacion } from '../../../../../asistente-en-linea/models/Validacion';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-delete-validacion-dialog',
  templateUrl: './delete-validacion-dialog.component.html',
  styleUrls: ['./delete-validacion-dialog.component.scss']
})
export class DeleteValidacionDialogComponent implements OnInit {               
  ejecutando : boolean;
  finalizado : boolean;
  mensaje: string;
  error: boolean;
  menuList:string[];
  constructor(private validacionesService: ValidacionesService,private authService: AuthService,public dialogRef: MatDialogRef<DeleteValidacionDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: Validacion) {
    this.ejecutando =  false;     
    this.finalizado =  false;  
    this.error =  false;                                                       
  }

  ngOnInit() {
  
  }

  cancelar(): void {
    this.dialogRef.close(false);                         
  }

  aceptar(): void {
    this.dialogRef.close(true);                        
  }

  
  deleteValidacion() {
    this.ejecutando =  true;     
    this.finalizado =  false;  
    this.error =  false;  
    if(this.data.id) {
      this.validacionesService.deleteValidacion(this.data.id,this.authService.getUser().username).subscribe((response: any) => {
        if (response && (response.statusCode == 200 ||response.statusCode ==0)) {
          this.finalizado =  true; 
        } else {
          this.mensaje = response.statusMessage;
          this.error =  true;
          this.ejecutando =  false; 
        }
      },
      error=>{
        this.mensaje = error;
        this.error =  true;
        this.ejecutando =  false; 
      })
    }
  }
}